const initState = () => {
  return {};
}

const contact = (state=initState(), action) => {
  switch (action.type) {
    case "CLEAR_CONTACT":
      return initState()

    case "UPDATE_CONTACT_NOTES":
      return {...state, ...{notes: action.payload}};

    case "UPDATE_CONTACT_AVATAR":
      const updateAvatar = `${state.avatar}?${new Date().getTime()}`;
      return {...state, ...{avatar: updateAvatar}};

    case "INIT_CONTACT":
      return {
        ...state,
        ...action.payload,
        ...{avatar: `${action.payload.avatar}?${new Date().getTime()}`}
      };

    default:
      return state;
  }
}

export default contact;
